import React from "react";
import classNames from "classnames";
import {CHAT_TYPE} from "utils/constants";
import Message from "./Components/Message";
import WorldChatPopUp from "./Components/WorldChatPopup";
import PersonalChatPopup from "./Components/PersonalChatPopup";
import QuickChat from "./Components/QuickChat";
import styles from "./index.module.scss";

export default function View({
  intl,
  isIPXMode,
  isSelfieModeActive,
  adInfo,
  chatType,
  chatList,
  chatOption,
  quickMessage,
  isClickNickName,
  chatListRef,
  chatListBottomRef,
  chatInputRef,
  onChangeChatMode,
  onSubmit,
  onClickChatType,
  onClickChatOption,
  setIsClickNickName,
  sendWorldMessage,
  selectedUser,
  setSelectedUser,
  isShowChat,
  isShowPrivatePopUp,
  setIsShowPrivatePopUp,
  onClickAdBanner,
}) {
  return (
    <div className={classNames(styles.chat, !isSelfieModeActive && isShowChat && styles.show)}>
      <ChatListWrap
        intl={intl}
        chatType={chatType}
        chatList={chatList}
        isClickNickName={isClickNickName}
        setIsClickNickName={setIsClickNickName}
        selectedUser={selectedUser}
        quickMessage={quickMessage}
        chatListRef={chatListRef}
        chatListBottomRef={chatListBottomRef}
        chatInputRef={chatInputRef}
        onChangeChatMode={onChangeChatMode}
        onSubmit={onSubmit}
        onClickChatType={onClickChatType}
      />
      {chatOption === CHAT_TYPE.WORLD_MESSAGE && (
        <WorldChatPopUp sendWorldMessage={sendWorldMessage} onClickChatOption={onClickChatOption} onChangeChatMode={onChangeChatMode} />
      )}
      {chatOption === CHAT_TYPE.PRIVATE_MESSAGE && (
        <PersonalChatPopup
          isShowPrivatePopUp={isShowPrivatePopUp}
          setSelectedUser={setSelectedUser}
          setIsShowPrivatePopUp={setIsShowPrivatePopUp}
          onClickChatType={onClickChatType}
          onClickChatOption={onClickChatOption}
        />
      )}
      <QuickChat isIPXMode={isIPXMode} onSubmit={onSubmit} onClickChatType={onClickChatType} />
      <Banner adInfo={adInfo} onClickAdBanner={onClickAdBanner} />
    </div>
  );
}

const Banner = ({adInfo, onClickAdBanner}) =>
  adInfo ? (
    <div className={styles.banner}>
      <img className={styles.banner_logo} src={adInfo.logo_img_path} alt="mezzomedia logo" onClick={() => onClickAdBanner("logo")} />
      <img className={styles.banner_img} src={adInfo.img_path} alt="ad" onClick={onClickAdBanner} />
    </div>
  ) : (
    <></>
  );

const ChatListWrap = ({
  intl,
  chatType,
  chatList,
  quickMessage,
  isClickNickName,
  chatListRef,
  chatListBottomRef,
  chatInputRef,
  onChangeChatMode,
  onSubmit,
  setIsClickNickName,
  onClickChatType,
  selectedUser,
}) => {
  return (
    <div className={styles.chat_list_box} ref={chatListRef}>
      <div className={styles.chat_list}>
        {chatList && chatList.map((data, i) => <Message key={i} data={data} />)}
        <div ref={chatListBottomRef} />
      </div>
      <ChatInput
        intl={intl}
        chatType={chatType}
        selectedUser={selectedUser}
        quickMessage={quickMessage}
        isClickNickName={isClickNickName}
        chatInputRef={chatInputRef}
        onChangeChatMode={onChangeChatMode}
        onSubmit={onSubmit}
        setIsClickNickName={setIsClickNickName}
        onClickChatType={onClickChatType}
      />
    </div>
  );
};

const ChatInput = ({
  intl,
  chatType,
  chatInputRef,
  selectedUser,
  isClickNickName,
  onClickChatType,
  onChangeChatMode,
  onSubmit,
  setIsClickNickName,
}) => {
  return (
    <div className={styles.chat_input_wrap}>
      {chatType === CHAT_TYPE.PRIVATE_MESSAGE && (
        <>
          {selectedUser && (
            <>
              {isClickNickName && (
                <div
                  className={styles.chat_message_option}
                  onClick={() => {
                    onClickChatType(CHAT_TYPE.MESSAGE);
                    setIsClickNickName(false);
                  }}
                >
                  {intl.formatMessage({id: "ID_PRIVATE_CHAT_MESSAGE_OPTION"})}
                </div>
              )}
              <div className={styles.chat_nickname} onClick={() => setIsClickNickName(!isClickNickName)}>
                {selectedUser.name}
              </div>
            </>
          )}
          <Input intl={intl} chatInputRef={chatInputRef} onChangeChatMode={onChangeChatMode} onSubmit={onSubmit} />
        </>
      )}
      {[CHAT_TYPE.WORLD_MESSAGE, CHAT_TYPE.MESSAGE].includes(chatType) && (
        <Input intl={intl} chatInputRef={chatInputRef} onChangeChatMode={onChangeChatMode} onSubmit={onSubmit} />
      )}
    </div>
  );
};

const Input = ({intl, chatInputRef, onChangeChatMode, onSubmit}) => (
  <input
    type="text"
    ref={chatInputRef}
    placeholder={intl.formatMessage({id: "ID_CHAT_INPUT_PLACEHOLDER"})}
    onClick={() => onChangeChatMode(true)}
    onChange={() => onChangeChatMode(true)}
    maxLength="500"
    onKeyPress={({key}) => key === "Enter" && onSubmit()}
  />
);
